var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Validation from "@irati/utils/validation";
import Form from "@irati/ui/src/Form";
import { Para } from "@irati/ui/src/Labels";
import Input from "@irati/ui/src/FormItem/Input";
import { Radio } from "@irati/ui/src/FormItem";
import DOBSelect from "@irati/ui/src/DOBSelect";
import authentication from "@irati/auth";
import { create } from "@irati/medical/services/medical";
import ContinueBackButtons from "../ContinueBackButtons";
import { SET_EMAIL } from "../../containers/Home/GetStarted";
var Content = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 360px;\n  margin: 0 auto;\n"], ["\n  max-width: 360px;\n  margin: 0 auto;\n"])));
var Description = styled(Para)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 415px;\n  margin: 0 auto 20px;\n"], ["\n  max-width: 415px;\n  margin: 0 auto 20px;\n"])));
var ProfileInformationStep = /** @class */ (function (_super) {
    __extends(ProfileInformationStep, _super);
    function ProfileInformationStep(props) {
        var _this = _super.call(this, props) || this;
        _this.buildGenders = function () {
            var formatMessage = _this.props.formatMessage;
            return [
                { label: formatMessage({ id: "medical.details.genders.options.female" }), value: "F" },
                { label: formatMessage({ id: "medical.details.genders.options.male" }), value: "M" },
                { label: formatMessage({ id: "medical.details.genders.options.ratherNotSay" }), value: "X" }
            ];
        };
        _this.proNounValidation = function () {
            return Validation.string().required(_this.props.formatMessage({ id: "platform.defaultValidation.radioRequired" }));
        };
        _this.mobileValidation = function () {
            var formatMessage = _this.props.formatMessage;
            /* eslint-disable */
            return Validation.string(formatMessage({ id: "platform.defaultValidation.required" }))
                .min(7, formatMessage({ id: "account.profile.fields.phone.validation.min" }))
                .max(15, formatMessage({ id: "account.profile.fields.phone.validation.max" }))
                .matches(/^[+]?([\d]{0,3})?[\(\.\-\s]?(([\d]{1,3})[\)\.\-\s]*)?(([\d]{3,5})[\.\-\s]?([\d]{4})|([\d]{2}[\.\-\s]?){4})$/, formatMessage({ id: "account.profile.fields.phone.validation.matches" }));
            /* eslint-enable */
        };
        _this.handleUpdatePhone = function (phone) {
            _this.setState(function (state) { return ({ account: __assign(__assign({}, state.account), { phone: phone }) }); });
        };
        _this.handleUpdateDOB = function (dob) {
            _this.setState(function (state) { return ({ account: __assign(__assign({}, state.account), { dob: dob }) }); });
        };
        _this.handleUpdateGender = function (gender) {
            _this.setState(function (state) { return ({ account: __assign(__assign({}, state.account), { gender: gender }) }); });
        };
        _this.handleCreateMedicalAccount = function () {
            var _a = _this.state.account, phone = _a.phone, gender = _a.gender, dob = _a.dob;
            var _b = _this.props, onCreateMedicalUser = _b.onCreateMedicalUser, email = _b.email;
            var data = {
                email: email,
                phoneNumber: phone,
                gender: gender,
                dob: dob
            };
            var load = create(data).then(function (user) {
                onCreateMedicalUser(user);
            });
            _this.setState({ load: load });
        };
        var _a = authentication.user(), dob = _a.dob, phone = _a.phone, gender = _a.gender;
        _this.state = {
            load: null,
            account: { dob: dob, phone: phone, gender: gender }
        };
        return _this;
    }
    ProfileInformationStep.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, onUpdateStep = _a.onUpdateStep;
        var _b = this.state, _c = _b.account, phone = _c.phone, dob = _c.dob, gender = _c.gender, load = _b.load;
        return (React.createElement(Form, null,
            React.createElement(Para, { center: true, large: true },
                React.createElement(FormattedMessage, { id: "medical.details.para" })),
            React.createElement(Description, { light: true, narrow: true },
                React.createElement(FormattedMessage, { id: "medical.details.desc" })),
            React.createElement(Content, null,
                React.createElement(DOBSelect, { isMinimumAge18: true, dayMonthYearRequired: true, label: formatMessage({ id: "medical.details.dob.label" }), value: dob, onChange: this.handleUpdateDOB }),
                React.createElement(Radio, { name: "preferredPronoun", label: formatMessage({ id: "medical.details.gender.label" }), value: gender, options: this.buildGenders(), onChange: this.handleUpdateGender, validation: this.proNounValidation() }),
                React.createElement(Input, { label: formatMessage({ id: "medical.details.phone.label" }), tooltip: formatMessage({ id: "medical.details.phone.tooltip" }), tooltipPosition: "top", customTooltip: true, placeholder: formatMessage({ id: "medical.details.phone.placeholder" }), value: phone, name: "phone", onChange: this.handleUpdatePhone, validation: this.mobileValidation() }),
                React.createElement(ContinueBackButtons, { load: load, onBack: function () { return onUpdateStep(SET_EMAIL); }, onContinue: this.handleCreateMedicalAccount }))));
    };
    ProfileInformationStep.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return ProfileInformationStep;
}(PureComponent));
export default injectIntl(ProfileInformationStep);
var templateObject_1, templateObject_2;
